import React from 'react';
import { Input } from 'antd'
import moment from 'moment';
import DateRangePicker from 'app/components/shared/app/DateRangePicker';
import ReactJsonViewer from 'app/lib/utils/ReactJsonViewer';
import IconCopy from 'components/shared/app/icons/IconCopy';
import { copyToClipboard } from 'app/lib/utils/adaya/AdayaUtils';

export const getDurationString = (start, end) => {
    return new Date(end).getTime() - new Date(start).getTime();
}

export const columns = [
    {
        title: 'Script Run Id',
        dataIndex: 'scriptRunId',
        sorter: (a, b) => a?.scriptRunId?.localeCompare(b?.scriptRunId),
        key: 'scriptRunId',
        shouldUseAsfilter: true,
    },
    {
        title: 'Script Name',
        dataIndex: 'scriptName',
        sorter: (a, b) => a?.scriptName?.localeCompare(b?.scriptName),
        key: 'scriptName',
        shouldUseAsfilter: true,
    },
    {
        title: 'Started At',
        dataIndex: 'startedAt',
        shouldUseAsfilter: true,
        key: 'startedAt',
        sorter: (a, b) => a?.startedAt?.localeCompare(b?.startedAt),
        name: "date",
        render: (d) => moment(d).format('M/D/YYYY @ H:M:SS A'),
        filterComponent: ({ onFilterChange, ...props }) => {
            return <div style={{ border: "1px solid #d9d9d9" }}><DateRangePicker onDateConfirm={onFilterChange} {...props} /></div>
        }
    },
    {
        title: 'Duration(ms)',
        // dataIndex: 'startedAt',
        key: 'Duration',
        sorter: (a, b) => getDurationString(a?.startedAt, a?.finishedAt) - getDurationString(b?.startedAt, b?.finishedAt),
        render: (_, record) => getDurationString(record?.startedAt, record?.finishedAt),
    },
    {
        title: 'Result',
        key: 'result',
        render: (data) => data.result ? <div><IconCopy style={{color:"#1e3e08"}} onClick={() => copyToClipboard(JSON.stringify(data.result))} /><ReactJsonViewer style={{ minWidth: "250px", maxWidth: "500px" }} src={data.result} collapsed={true} /></div> : ""
    },
    {
        title: 'Parameters',
        key: 'Parameters',
        render: (data) => data.parameters ? <div><IconCopy style={{color:"#1e3e08"}} onClick={() => copyToClipboard(JSON.stringify(data.parameters))} /><ReactJsonViewer style={{ minWidth: "250px", maxWidth: "500px" }} src={data.parameters} collapsed={true} /></div> : ""
    },
];

export const formSchema = [
    {
        props: {
            name: "scriptRunId",
            label: "Script Run Id"
        },
        component: Input,
    },
    {
        props: {
            name: "scriptName",
            label: "Script Name"
        },
        component: Input,
    }
]
